export default __webpack_public_path__ + "static/am-master-to-excel-8059f677ba508aa2703ccc8f6eccc080.gif";